var _rect, _rect2, _path, _path2, _path3, _rect3, _rect4, _rect5, _path4, _path5, _path6, _rect6, _rect7, _rect8, _path7, _path8, _path9, _rect9, _rect0, _rect1, _path0, _path1, _path10, _rect10, _rect11, _rect12, _path11, _path12, _path13, _rect13, _rect14, _rect15, _path14, _path15, _path16, _rect16, _rect17, _rect18, _path17, _path18, _path19, _rect19, _path20, _circle, _circle2, _circle3, _circle4, _path21, _path22, _path23, _path24, _circle5, _circle6, _rect20;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollectivePhoneFreeTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 267,
    height: 148,
    viewBox: "0 0 267 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.06732,
    y: -0.927808,
    width: 50,
    height: 50,
    rx: 25,
    transform: "matrix(-0.997564 -0.0697565 -0.0697565 0.997564 214.684 3.80461)",
    fill: "#EB5756"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.06732,
    y: -0.927808,
    width: 50,
    height: 50,
    rx: 25,
    transform: "matrix(-0.997564 -0.0697565 -0.0697565 0.997564 214.684 3.80461)",
    stroke: "#F9E5E0",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M173.137 12.5381L197.973 41.1094",
    stroke: "#24284E",
    strokeWidth: 1.84615,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M179.416 15.3697L179.614 12.5283C179.65 12.0197 180.091 11.6363 180.6 11.6718L195.333 12.7021C195.841 12.7376 196.225 13.1787 196.189 13.6873L194.883 32.3736C194.854 32.7837 194.344 32.9545 194.074 32.6442L179.64 16.0397C179.479 15.8549 179.399 15.6139 179.416 15.3697Z",
    fill: "#24284E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M194.521 37.5501L194.387 39.4708C194.351 39.9793 193.91 40.3628 193.401 40.3272L178.668 39.297C178.16 39.2614 177.776 38.8203 177.812 38.3117L179.054 20.5463C179.083 20.1361 179.593 19.9654 179.863 20.2757L194.297 36.8801C194.457 37.0649 194.538 37.3059 194.521 37.5501Z",
    fill: "#24284E"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 185.107,
    y: 13.376,
    width: 5.53846,
    height: 1.38462,
    rx: 0.692308,
    transform: "rotate(4 185.107 13.376)",
    fill: "#EB5756"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 1.21222,
    y: -0.728374,
    width: 50,
    height: 50,
    rx: 25,
    transform: "matrix(-0.970296 -0.241922 -0.241922 0.970296 235.305 48.7902)",
    fill: "#EB5756"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 1.21222,
    y: -0.728374,
    width: 50,
    height: 50,
    rx: 25,
    transform: "matrix(-0.970296 -0.241922 -0.241922 0.970296 235.305 48.7902)",
    stroke: "#F9E5E0",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M192.684 50.335L212.182 82.7851",
    stroke: "#24284E",
    strokeWidth: 1.84615,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M198.376 54.2142L199.065 51.4503C199.188 50.9557 199.689 50.6547 200.184 50.778L214.514 54.351C215.009 54.4743 215.31 54.9753 215.187 55.47L210.655 73.6455C210.555 74.0444 210.023 74.124 209.812 73.7715L198.48 54.9129C198.354 54.703 198.316 54.4517 198.376 54.2142Z",
    fill: "#24284E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M209.4 78.6805L208.934 80.5487C208.811 81.0433 208.31 81.3444 207.815 81.221L193.485 77.648C192.99 77.5247 192.689 77.0237 192.812 76.5291L197.121 59.2492C197.22 58.8503 197.752 58.7707 197.964 59.1232L209.296 77.9818C209.422 78.1916 209.459 78.443 209.4 78.6805Z",
    fill: "#24284E"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 204.327,
    y: 53.2383,
    width: 5.53846,
    height: 1.38462,
    rx: 0.692308,
    transform: "rotate(14 204.327 53.2383)",
    fill: "#EB5756"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 136.094,
    y: 61.0479,
    width: 58,
    height: 58,
    rx: 29,
    transform: "rotate(4 136.094 61.0479)",
    fill: "#EB5756"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 136.094,
    y: 61.0479,
    width: 58,
    height: 58,
    rx: 29,
    transform: "rotate(4 136.094 61.0479)",
    stroke: "#F9E5E0",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M181.203 78.6992L147.87 107.675",
    stroke: "#24284E",
    strokeWidth: 2.15385,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M173.489 80.9509L173.721 77.6358C173.762 77.0425 173.315 76.5279 172.722 76.4864L155.533 75.2844C154.939 75.243 154.425 75.6903 154.383 76.2836L152.859 98.0843C152.825 98.5628 153.387 98.8429 153.749 98.5282L173.121 81.6885C173.337 81.5011 173.469 81.2358 173.489 80.9509Z",
    fill: "#24284E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M152.437 104.123L152.28 106.364C152.239 106.957 152.686 107.472 153.279 107.514L170.468 108.716C171.061 108.757 171.576 108.31 171.618 107.716L173.067 86.99C173.1 86.5115 172.539 86.2314 172.177 86.5461L152.805 103.386C152.589 103.573 152.457 103.838 152.437 104.123Z",
    fill: "#24284E"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 6.46154,
    height: 1.61538,
    rx: 0.807692,
    transform: "matrix(-0.997564 -0.0697565 -0.0697565 0.997564 167.237 77.7227)",
    fill: "#EB5756"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 0.909039,
    y: -1.08335,
    width: 58,
    height: 58,
    rx: 29,
    transform: "matrix(-0.996195 0.0871557 0.0871557 0.996195 168.362 11.5827)",
    fill: "#EB5756"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 0.909039,
    y: -1.08335,
    width: 58,
    height: 58,
    rx: 29,
    transform: "matrix(-0.996195 0.0871557 0.0871557 0.996195 168.362 11.5827)",
    stroke: "#F9E5E0",
    strokeWidth: 2
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M122.568 29.0186L156.402 57.4085",
    stroke: "#24284E",
    strokeWidth: 2.15385,
    strokeLinecap: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M130.32 31.1353L130.03 27.8248C129.979 27.2323 130.417 26.7099 131.009 26.6581L148.175 25.1563C148.767 25.1045 149.289 25.5428 149.341 26.1353L151.246 47.906C151.288 48.3839 150.731 48.6738 150.363 48.3654L130.701 31.8664C130.482 31.6828 130.345 31.4198 130.32 31.1353Z",
    fill: "#24284E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M151.774 53.9366L151.97 56.1742C152.021 56.7668 151.583 57.2891 150.991 57.3409L133.825 58.8427C133.233 58.8945 132.711 58.4562 132.659 57.8637L130.848 37.1658C130.806 36.6879 131.363 36.3981 131.73 36.7064L151.393 53.2055C151.612 53.389 151.749 53.652 151.774 53.9366Z",
    fill: "#24284E"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 136.515,
    y: 27.7979,
    width: 6.46154,
    height: 1.61538,
    rx: 0.807692,
    transform: "rotate(-5 136.515 27.7979)",
    fill: "#EB5756"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 81.4674,
    y: 59.5226,
    width: 58,
    height: 58,
    rx: 29,
    transform: "rotate(-5 81.4674 59.5226)",
    fill: "#EB5756"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 81.4674,
    y: 59.5226,
    width: 58,
    height: 58,
    rx: 29,
    transform: "rotate(-5 81.4674 59.5226)",
    stroke: "#F9E5E0",
    strokeWidth: 2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M128.783 69.9004L100.393 103.734",
    stroke: "#24284E",
    strokeWidth: 2.15385,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M121.515 73.3306L121.226 70.0201C121.174 69.4276 120.652 68.9893 120.059 69.0411L102.894 70.5429C102.301 70.5947 101.863 71.1171 101.915 71.7096L103.82 93.4803C103.861 93.9582 104.46 94.147 104.768 93.7795L121.267 74.1167C121.451 73.8979 121.54 73.6151 121.515 73.3306Z",
    fill: "#24284E"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M104.347 99.5118L104.543 101.749C104.595 102.342 105.117 102.78 105.71 102.728L122.875 101.227C123.467 101.175 123.906 100.652 123.854 100.06L122.043 79.3621C122.001 78.8842 121.402 78.6954 121.094 79.0629L104.595 98.7257C104.411 98.9445 104.322 99.2272 104.347 99.5118Z",
    fill: "#24284E"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 6.46154,
    height: 1.61538,
    rx: 0.807692,
    transform: "matrix(-0.996195 0.0871557 0.0871557 0.996195 114.836 71.1201)",
    fill: "#EB5756"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 0.889993,
    y: -1.09905,
    width: 50,
    height: 50,
    rx: 25,
    transform: "matrix(-0.994522 0.104528 0.104528 0.994522 98.2503 32.523)",
    fill: "#EB5756"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 0.889993,
    y: -1.09905,
    width: 50,
    height: 50,
    rx: 25,
    transform: "matrix(-0.994522 0.104528 0.104528 0.994522 98.2503 32.523)",
    stroke: "#F9E5E0",
    strokeWidth: 2
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0098 48.1494L88.4305 71.9739",
    stroke: "#24284E",
    strokeWidth: 1.84615,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6852 49.8485L65.3875 47.0157C65.3342 46.5087 65.702 46.0545 66.209 46.0012L80.8974 44.4574C81.4044 44.4041 81.8586 44.7719 81.9119 45.2789L83.8699 63.9082C83.9129 64.3171 83.44 64.5739 83.1204 64.3151L66.0224 50.4694C65.8321 50.3153 65.7108 50.092 65.6852 49.8485Z",
    fill: "#24284E"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M84.4122 69.0686L84.6135 70.9833C84.6668 71.4904 84.2989 71.9446 83.7919 71.9979L69.1036 73.5417C68.5966 73.5949 68.1424 73.2271 68.0891 72.7201L66.2276 55.0089C66.1846 54.5999 66.6575 54.3432 66.977 54.6019L84.0751 68.4477C84.2654 68.6017 84.3866 68.8251 84.4122 69.0686Z",
    fill: "#24284E"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 70.9434,
    y: 46.8955,
    width: 5.53846,
    height: 1.38462,
    rx: 0.692308,
    transform: "rotate(-6 70.9434 46.8955)",
    fill: "#EB5756"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 0.909039,
    y: -1.08335,
    width: 44,
    height: 44,
    rx: 22,
    transform: "matrix(-0.996195 0.0871557 0.0871557 0.996195 117.998 0.165673)",
    fill: "#EB5756"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 0.909039,
    y: -1.08335,
    width: 44,
    height: 44,
    rx: 22,
    transform: "matrix(-0.996195 0.0871557 0.0871557 0.996195 117.998 0.165673)",
    stroke: "#F9E5E0",
    strokeWidth: 2
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M83.1748 13.2637L108.55 34.5562",
    stroke: "#24284E",
    strokeWidth: 1.61538,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9888 14.851L88.7716 12.3681C88.7327 11.9237 89.0614 11.532 89.5058 11.4931L102.38 10.3668C102.824 10.3279 103.216 10.6566 103.255 11.101L104.683 27.429C104.715 27.7874 104.297 28.0049 104.021 27.7736L89.2742 15.3993C89.1101 15.2616 89.0075 15.0644 88.9888 14.851Z",
    fill: "#24284E"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M105.08 31.9527L105.226 33.6309C105.265 34.0753 104.937 34.4671 104.492 34.5059L91.6184 35.6323C91.174 35.6711 90.7822 35.3424 90.7433 34.898L89.3852 19.3746C89.3539 19.0162 89.7715 18.7988 90.0471 19.0301L104.794 31.4043C104.958 31.542 105.061 31.7393 105.08 31.9527Z",
    fill: "#24284E"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 93.6348,
    y: 12.3486,
    width: 4.84615,
    height: 1.21154,
    rx: 0.605769,
    transform: "rotate(-5 93.6348 12.3486)",
    fill: "#EB5756"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63 90C63 88.8954 63.8954 88 65 88H85.2654C86.2607 88 87.1046 88.7319 87.2453 89.7172L90.7547 114.283C90.8954 115.268 91.7393 116 92.7346 116H193.265C194.261 116 195.105 115.268 195.245 114.283L198.755 89.7172C198.895 88.7319 199.739 88 200.735 88H221C222.105 88 223 88.8954 223 90V116V142C223 143.105 222.105 144 221 144H191H95H65C63.8954 144 63 143.105 63 142V116V90Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 33.5,
    cy: 122.5,
    r: 1.5,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 47.5,
    r: 1.5,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 265.5,
    cy: 40.5,
    r: 1.5,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 57.5,
    cy: 8.5,
    r: 1.5,
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M18 20L37 24.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 84.5L36.5 79.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M226 23.5L244.5 18.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M242 71.5L261 75.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 251.5,
    cy: 111.5,
    r: 1.5,
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 157.5,
    cy: 1.5,
    r: 1.5,
    fill: "white"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.04,
    width: 216,
    height: 4,
    rx: 2,
    transform: "matrix(1 0 0 -1 35 148)",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollectivePhoneFreeTime);
export default __webpack_public_path__ + "static/media/collective-phone-free-time.1112e1c4068914f85dda6732d6b119fb.svg";
export { ForwardRef as ReactComponent };